<template>
  <UmisisModal
    ref="finalApproverModal"
    title="Change Final Approver"
    :ok-disabled="isUpdating || isLoadingUsers || !canSubmit"
    @show="handleShow"
    @ok="handleSubmit"
  >
    <div class="flex flex-col gap-4">
      <Field>
        <FieldLabel for="review-process-final-approver-existing">
          Select final approver
        </FieldLabel>
        <select
          id="review-process-final-approver-existing"
          v-model.number="selectedFinalApproverModel"
          class="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
          :disabled="isUpdating || isLoadingUsers"
        >
          <option :value="null" disabled>
            Choose a user
          </option>
          <option v-for="user in users" :key="`review-final-approver-update-${user.id}`" :value="user.id">
            {{ user.name }} ({{ user.email }})
          </option>
        </select>
        <FieldDescription>
          Available while review is not submitted, rejected, or withdrawn.
        </FieldDescription>
      </Field>
    </div>
  </UmisisModal>
</template>

<script setup>
import { computed } from 'vue'
import UmisisModal from '../../../../../../../resources/js/components/umisis/generic/UmisisModal.vue'
import { useModalControl } from '../../../../../../../resources/js/composables/modal/useUmisisModal.js'
import { Field, FieldDescription, FieldLabel } from '../../../../../../../resources/js/components/ui/field/index.js'

const props = defineProps({
  selectedFinalApproverId: {
    type: [Number, String],
    default: null,
  },
  isLoadingUsers: {
    type: Boolean,
    default: false,
  },
  isUpdating: {
    type: Boolean,
    default: false,
  },
  canSubmit: {
    type: Boolean,
    default: false,
  },
  users: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['show', 'submit', 'update:selectedFinalApproverId'])

const { componentRef: finalApproverModal, openModal: openDialog, closeModal: closeDialog } = useModalControl()

const selectedFinalApproverModel = computed({
  get() {
    return props.selectedFinalApproverId
  },
  set(value) {
    const normalizedValue = Number(value)

    emit(
      'update:selectedFinalApproverId',
      Number.isInteger(normalizedValue) && normalizedValue > 0 ? normalizedValue : null
    )
  },
})

const openModal = () => {
  openDialog()
}

const closeModal = () => {
  closeDialog()
}

const handleShow = () => {
  emit('show')
}

const handleSubmit = (event) => {
  emit('submit', event)
}

defineExpose({
  openModal,
  closeModal,
})
</script>
